module.exports = __webpack_public_path__ + "img/closed-eye-woman.bce00cfc.jpg";